import { Action } from '@ngrx/store';
import { AddressInterface } from '../../models/address.interface';
import { MfaInterface } from '../../../shared/models/mfa.interface';

export enum EAddressActions {
  GetAddress = '[Address] Get shipping address',
  GetAddressSuccess = '[Address] Get shipping address success',
  GetAddressFailure = '[Address] Get shipping address failure',

  UpdateShippingAddress = '[Address] Update shipping address',
  UpdateAddressSuccess = '[Address] Update shipping address success',
  UpdateAddressFailure = '[Address] Update shipping address failure',

  SetPrincipalAddress = '[Address] Set principal shipping address',
  SetPrincipalAddressSuccess = '[Address] Set principal shipping address success',
  SetPrincipalAddressFailure = '[Address] Set principal shipping address failure',

  DeleteShippingAddress = '[Address] Delete shipping address',
  DeleteShippingAddressSuccess = '[Address] Delete shipping address success',
  DeleteShippingAddressFailure = '[Address] Delete shipping address failure',

  CreateShippingAddress = '[Address] Create principal shipping address',
  CreateShippingAddressSuccess = '[Address] Create shipping address success',
  CreateShippingAddressFailure = '[Address] Create shipping address failure',
}

/**
 * Set update address action and state to save in store
 */
export class UpdateShippingAddress implements Action {
  public readonly type = EAddressActions.UpdateShippingAddress;
  // payload passed as param and will be used by the effect
  constructor(
      public payload: AddressInterface,
      public mfa: MfaInterface | null = null
  ) {}
}

/**
 * Set update address success action and state to save in store
 */
export class UpdateAddressSuccess implements Action {
  public readonly type = EAddressActions.UpdateAddressSuccess;
}

/**
 * Set update address failure action and state to save in store
 */
export class UpdateAddressFailure implements Action {
  public readonly type = EAddressActions.UpdateAddressFailure;
}

/**
 * Get address action and state to save in store
 */
export class GetAddress implements Action {
  public readonly type = EAddressActions.GetAddress;
}

/**
 * Get address success action and state to save in store
 */
export class GetAddressSuccess implements Action {
  public readonly type = EAddressActions.GetAddressSuccess;
  constructor(public payload: Array<AddressInterface>) {}
}

/**
 * Get address failure action and state to save in store
 */
export class GetAddressFailure implements Action {
  public readonly type = EAddressActions.GetAddressFailure;
}

/**
 * Set principal address action and state to save in store
 */
export class SetPrincipalAddress implements Action {
  public readonly type = EAddressActions.SetPrincipalAddress;
  constructor(public id: number, public isPrincipal: boolean, public password?: string) {}
}

/**
 * Set principal address success action and state to save in store
 */
export class SetPrincipalAddressSuccess implements Action {
  public readonly type = EAddressActions.SetPrincipalAddressSuccess;
}

/**
 * Set principal address failure action and state to save in store
 */
export class SetPrincipalAddressFailure implements Action {
  public readonly type = EAddressActions.SetPrincipalAddressFailure;
}

/**
 * Delete address action and state to save in store
 */
export class DeleteShippingAddress implements Action {
  public readonly type = EAddressActions.DeleteShippingAddress;
  constructor(public id: number, public password?: string) {}
}

/**
 * Delete principal address success action and state to save in store
 */
export class DeleteShippingAddressSuccess implements Action {
  public readonly type = EAddressActions.DeleteShippingAddressSuccess;
}

/**
 * Delete principal address failure action and state to save in store
 */
export class DeleteShippingAddressFailure implements Action {
  public readonly type = EAddressActions.DeleteShippingAddressFailure;
}

/**
 * Create shipping address action and state to save in store
 */
export class CreateShippingAddress implements Action {
  public readonly type = EAddressActions.CreateShippingAddress;
  // payload passed as param and will be used by the effect
  constructor(
      public payload: AddressInterface,
      public mfa: MfaInterface | null = null
  ) {}
}

/**
 * Create shipping address success action and state to save in store
 */
export class CreateShippingAddressSuccess implements Action {
  public readonly type = EAddressActions.CreateShippingAddressSuccess;
}

/**
 * Create shipping address failure action and state to save in store
 */
export class CreateShippingAddressFailure implements Action {
  public readonly type = EAddressActions.CreateShippingAddressFailure;
}

/**
 * Export actions : will be used in reducers
 */
export type AddressActions =
    UpdateShippingAddress |
    UpdateAddressSuccess |
    UpdateAddressFailure |
    GetAddress|
    GetAddressSuccess |
    GetAddressFailure |
    SetPrincipalAddress |
    SetPrincipalAddressSuccess |
    SetPrincipalAddressFailure |
    DeleteShippingAddress |
    DeleteShippingAddressSuccess |
    DeleteShippingAddressFailure |
    CreateShippingAddress |
    CreateShippingAddressSuccess |
    CreateShippingAddressFailure;
